import { Controller, useFormContext } from 'react-hook-form';
import { FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import { type SourceOfWealth as SourceOfWealthType } from '@shared/api';
import { Constants } from '@shared';

const SOURCES_OF_SAVINGS_OPTIONS = Object.keys(Constants.SOURCES_OF_WEALTH)
  .filter((key) => key !== 'Savings' && key !== 'Guarantor')
  .map((key) => ({
    value: key,
    label: Constants.SOURCES_OF_WEALTH[key as SourceOfWealthType],
  }));

interface ISavingsProps {
  name: string;
}

export const Savings = (props: ISavingsProps) => {
  const { control, setValue } = useFormContext();

  const reset = (value: string) => {
    setValue(`${props.name}.sourceOfSavings`, {});
    switch (value) {
      case 'Employment':
        setValue(`${props.name}.sourceOfSavings.position`, '');
        setValue(`${props.name}.sourceOfSavings.employer`, '');
        setValue(`${props.name}.sourceOfSavings.country`, '');
        setValue(`${props.name}.sourceOfSavings.date`, '');
        setValue(`${props.name}.sourceOfSavings.economicActivity`, '');
        break;
      case 'FamilyWealth':
        setValue(`${props.name}.sourceOfSavings.description`, '');
        setValue(`${props.name}.sourceOfSavings.relation`, '');
        setValue(`${props.name}.sourceOfSavings.country`, '');
        break;
      case 'Inheritance':
        setValue(`${props.name}.sourceOfSavings.description`, '');
        setValue(`${props.name}.sourceOfSavings.relation`, '');
        setValue(`${props.name}.sourceOfSavings.country`, '');
        setValue(`${props.name}.sourceOfSavings.year`, '');
        break;
      case 'Business':
        setValue(`${props.name}.sourceOfSavings.employer`, '');
        setValue(`${props.name}.sourceOfSavings.country`, '');
        setValue(`${props.name}.sourceOfSavings.economicActivity`, '');
        break;
      case 'SalesOfAssets':
        setValue(`${props.name}.sourceOfSavings.asset`, '');
        setValue(`${props.name}.sourceOfSavings.value`, '');
        setValue(`${props.name}.sourceOfSavings.country`, '');
        setValue(`${props.name}.sourceOfSavings.date`, '');
        break;
    }
  };

  return (
    <Grid item xs={12}>
      <Controller
        name={`${props.name}.sourceOfSavings.source`}
        control={control}
        rules={{ required: 'Source of Savings is required' }}
        render={({ field, fieldState: { error } }) => (
          <>
            <FormControl margin='normal' fullWidth error={!!error}>
              <InputLabel>Source of Savings *</InputLabel>
              <Select
                {...field}
                variant='standard'
                fullWidth
                onChange={(e) => {
                  reset(e.target.value);
                  field.onChange(e);
                }}
              >
                {SOURCES_OF_SAVINGS_OPTIONS.map(({ label, value }, idx) => (
                  <MenuItem key={idx} value={value}>
                    {label}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{error?.message}</FormHelperText>
            </FormControl>
          </>
        )}
      />
    </Grid>
  );
};
